var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIlSearchstack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "61px",
    viewBox: "0 0 64 61",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 52") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.01-Dashboard-Product-Search-(no-results)",
    transform: "translate(-154.000000, -368.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-47-Copy",
    transform: "translate(0.000000, 119.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-53",
    transform: "translate(77.000000, 249.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-52",
    transform: "translate(74.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.1630304,17.3905195 L64.7660006,35.1352861 C66.6242808,36.3298948 67.1622928,38.8047502 65.9676841,40.6630304 C65.6578202,41.145041 65.2480112,41.5548499 64.7660006,41.8647139 L37.1630304,59.6094805 C35.8453999,60.4565286 34.1546001,60.4565286 32.8369696,59.6094805 L5.2339994,41.8647139 C3.37571923,40.6701052 2.83770718,38.1952498 4.03231587,36.3369696 C4.34217982,35.854959 4.7519888,35.4451501 5.2339994,35.1352861 L32.8369696,17.3905195 C34.1546001,16.5434714 35.8453999,16.5434714 37.1630304,17.3905195 Z",
    id: "Rectangle-Copy-9",
    fill: "#E7E8EF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1630304,9.39051952 L64.7660006,27.1352861 C66.6242808,28.3298948 67.1622928,30.8047502 65.9676841,32.6630304 C65.6578202,33.145041 65.2480112,33.5548499 64.7660006,33.8647139 L37.1630304,51.6094805 C35.8453999,52.4565286 34.1546001,52.4565286 32.8369696,51.6094805 L5.2339994,33.8647139 C3.37571923,32.6701052 2.83770718,30.1952498 4.03231587,28.3369696 C4.34217982,27.854959 4.7519888,27.4451501 5.2339994,27.1352861 L32.8369696,9.39051952 C34.1546001,8.54347139 35.8453999,8.54347139 37.1630304,9.39051952 Z",
    id: "Rectangle-Copy-8",
    fill: "#CFD1DE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1630304,1.39051952 L64.7660006,19.1352861 C66.6242808,20.3298948 67.1622928,22.8047502 65.9676841,24.6630304 C65.6578202,25.145041 65.2480112,25.5548499 64.7660006,25.8647139 L37.1630304,43.6094805 C35.8453999,44.4565286 34.1546001,44.4565286 32.8369696,43.6094805 L5.2339994,25.8647139 C3.37571923,24.6701052 2.83770718,22.1952498 4.03231587,20.3369696 C4.34217982,19.854959 4.7519888,19.4451501 5.2339994,19.1352861 L32.8369696,1.39051952 C34.1546001,0.543471389 35.8453999,0.543471389 37.1630304,1.39051952 Z",
    id: "Rectangle",
    fill: "#C3C6D6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic_search",
    opacity: 0.600000024,
    transform: "translate(35.500000, 22.000000) scale(-1, 1) translate(-35.500000, -22.000000) translate(23.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-1",
    strokeOpacity: 0.00784313771,
    stroke: "#000000",
    strokeWidth: 1.33333335e-11,
    transform: "translate(12.500000, 9.000000) scale(-1, 1) translate(-12.500000, -9.000000) ",
    points: "0 0 25 0 25 18 0 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8484833,5.9620246 C15.8484833,7.33224924 15.1236458,8.50180957 13.6739728,9.47070555 C12.2242989,10.4396009 10.4743884,10.9240492 8.42424165,10.9240492 C6.3740938,10.9240492 4.62418339,10.4396009 3.17450993,9.47070555 C1.72483648,8.50180957 1,7.33224924 1,5.9620246 C1,4.59179925 1.72483648,3.42223893 3.17450993,2.45334329 C4.62418339,1.48444765 6.3740938,1 8.42424165,1 C10.4743884,1 12.2242989,1.48444765 13.6739728,2.45334329 C15.1236458,3.42223893 15.8484833,4.59179925 15.8484833,5.9620246 Z M14.6287868,9.08101121 L21.8409085,13.9012645 C22.0530305,14.0430372 22.0530305,14.2556948 21.8409085,14.3974675 L21.0984836,14.8936705 C20.8863616,15.0354432 20.5681806,15.0354432 20.3560586,14.8936705 L13.0909074,10.1088597 L14.6287868,9.08101121 Z",
    id: "Combined-Shape",
    stroke: "#FFFFFF",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlSearchstack);
export default __webpack_public_path__ + "static/media/il_searchstack.ddbe6df20c87501c38cbf201ba9f3491.svg";
export { ForwardRef as ReactComponent };